import { HorizontalSeparator } from "common/common.styled";
import Grid from "components/Grid";
import Text from "components/Text";
import { routeConstants } from "constants/routeConstants";
import { CircularButton } from "pages/Profile/EditProfile/PersonalDetails/PersonalDetails.styled";
import { FC, useState } from "react";
import {
    FaCalendarAlt,
    FaRulerVertical,
    FaUser,
    FaWeight,
} from "react-icons/fa";
import { RiArrowLeftRightFill, RiArrowRightFill } from "react-icons/ri";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setModelProfile } from "slice/model";
import { User } from "slice/user/types";
import theme from "theme";
import logo from "images/logo.svg";
import {
    BackHeader,
    CardBack,
    CardFront,
    CardHeart,
    CardInner,
    DetailItem,
    DetailsList,
    ImgOverlaySection,
    ImgSection,
    TalentCardBody,
    TalentCardHeader,
    TalentCardWrapper,
    ViewProfileButton,
} from "../FindTalent.styled";

export const TalentCard: FC<User> = ({
    first_name,
    last_name,
    nationality,
    profile_image,
    id,
    gender,
    dob,
    physical_details,
    qualification,
}) => {
    const [isFlipped, setIsFlipped] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isActive, setIsActive] = useState(false);
    return (
        <TalentCardWrapper isFlipped={isFlipped}>
            <CardInner>
                <CardFront>
                    <TalentCardHeader>
                        <ImgSection img={profile_image || logo}>
                            <ImgOverlaySection>
                                <Text
                                    variant="heading5"
                                    fontWeight="500"
                                    color="#fff"
                                >
                                    {first_name} {last_name}
                                </Text>
                                <HorizontalSeparator width="10%" />
                                <Text variant="body1" color="#fff">
                                    Commercial Model
                                </Text>
                            </ImgOverlaySection>
                        </ImgSection>
                        {/*<CardHeart*/}
                        {/*    isActive={isActive}*/}
                        {/*    onClick={() => setIsActive(!isActive)}*/}
                        {/*/>*/}
                    </TalentCardHeader>
                    <TalentCardBody>
                        <Grid row={true} alignItems="center">
                            {/* <CountryIcon src={UAEFlag} alt="country icon" /> */}
                            <Text
                                variant="body3"
                                color={theme.colors.grey.dark}
                            >
                                {nationality}
                            </Text>
                        </Grid>
                        {/* <HorizontalSeparator margin="1rem 0" />
                <Grid
                    row={true}
                    alignItems="center"
                    expanded
                    justify="center"
                    columnGap={2}
                >
                    <Stat marginRight>
                        <Text
                            variant="heading6"
                            color={theme.colors.purple.primary}
                        >
                            21.5k
                        </Text>
                        <Text
                            variant="body3"
                            fontSize="10px"
                            color={theme.colors.grey.secondary}
                        >
                            INSTAGRAM
                        </Text>
                    </Stat>
                    <Stat>
                        <Text
                            variant="heading6"
                            color={theme.colors.purple.primary}
                        >
                            366
                        </Text>
                        <Text
                            variant="body3"
                            fontSize="10px"
                            color={theme.colors.grey.secondary}
                        >
                            PROFILE VISITS
                        </Text>
                    </Stat>
                </Grid> */}
                        <Grid row={true} columnGap={1} marginTop={1}>
                            <CircularButton
                                variant="flat"
                                onClick={() => setIsFlipped(!isFlipped)}
                            >
                                <RiArrowLeftRightFill />
                            </CircularButton>
                            <ViewProfileButton
                                icon={<RiArrowRightFill />}
                                iconPosition="suffix"
                                onClick={() => {
                                    dispatch(setModelProfile(undefined));
                                    navigate(
                                        routeConstants.findTalentRoot.root +
                                            routeConstants.findTalentRoot.model,
                                        {
                                            state: {
                                                model_id: id,
                                            },
                                        }
                                    );
                                }}
                            >
                                View Profile
                            </ViewProfileButton>
                        </Grid>
                    </TalentCardBody>
                </CardFront>
                {/* Back Side */}
                <CardBack>
                    <BackHeader>
                        <h3
                            style={{
                                color: theme.colors.purple.primary,
                            }}
                        >
                            Details
                        </h3>
                    </BackHeader>
                    <DetailsList>
                        <DetailItem>
                            <FaUser /> <strong>Gender:</strong> {gender}
                        </DetailItem>
                        <DetailItem>
                            <FaCalendarAlt /> <strong>DOB:</strong> {dob}
                        </DetailItem>
                        {/* <DetailItem>
                            <FaChalkboardTeacher />
                            <strong>Qualification:</strong> {qualification}
                        </DetailItem> */}
                        <DetailItem>
                            <FaRulerVertical /> <strong>Height:</strong>{" "}
                            {physical_details?.height
                                ? physical_details?.height + " cm"
                                : "-"}
                        </DetailItem>
                        <DetailItem>
                            <FaWeight /> <strong>Weight:</strong>{" "}
                            {physical_details?.weight
                                ? physical_details?.weight + " kg"
                                : "-"}
                        </DetailItem>
                    </DetailsList>
                    <CircularButton onClick={() => setIsFlipped(false)}>
                        <RiArrowLeftRightFill />
                    </CircularButton>
                </CardBack>
            </CardInner>
        </TalentCardWrapper>
    );
};
